import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { FaSpinner } from "react-icons/fa";

export const PaymentForm = ({ onClose }) => {
    const location = useLocation();
    const [userData, setUserData] = useState(null);
    const [file, setFile] = useState(null);
    const [amount, setAmount] = useState("");
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState("");
    const [selectedMonth, setSelectedMonth] = useState("");
    const [uploadProgress, setUploadProgress] = useState(0);
    const [isUploadComplete, setIsUploadComplete] = useState(false);
    const [reload, setReload] = useState(false);

    const months = [
        "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
        "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre",
    ];

    // Cargar datos del usuario al abrir el modal
    useEffect(() => {
        const storedUserData = localStorage.getItem("userSession");
        if (storedUserData) {
            const parsedData = JSON.parse(storedUserData);
            setUserData(parsedData.cliente);
        }
    }, [reload]);

    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];
        setFile(selectedFile);
        setIsUploadComplete(false);
        setUploadProgress(0);

        if (selectedFile) {
            const reader = new FileReader();
            reader.onloadstart = () => setUploadProgress(0);
            reader.onprogress = (event) => {
                if (event.lengthComputable) {
                    setUploadProgress(Math.round((event.loaded / event.total) * 100));
                }
            };
            reader.onloadend = () => {
                setUploadProgress(100);
                setIsUploadComplete(true);
            };
            reader.readAsArrayBuffer(selectedFile);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!file || !amount || !selectedMonth) {
            setMessage("Por favor, complete todos los campos.");
            return;
        }

        setLoading(true);

        try {
            // Subir archivo
            const formData = new FormData();
            formData.append("filename", file);
            formData.append("amount", amount);

            const uploadRes = await fetch(
                `https://netmax-play-api.vercel.app/api/v1/clientes/${userData?.Id}/comprobantes`,
                { method: "POST", body: formData }
            );

            if (!uploadRes.ok) throw new Error("Error al enviar el comprobante");
            const { url: uploadedUrl } = await uploadRes.json();

            // Tomar datos más recientes de localStorage
            const storedUserData = JSON.parse(localStorage.getItem("userSession"));
            const currentData = storedUserData.cliente;

            // Actualizar solo el comprobante del mes seleccionado
            const updatedConexion = currentData.Conexion.map(conexion => {
                const updatedComprobantes = conexion.Comprobantes.map(c =>
                    c.mes === selectedMonth ? { ...c, link: uploadedUrl, pago: true } : c
                );
                return { ...conexion, Comprobantes: updatedComprobantes };
            });

            // Guardar en la API
            await fetch(
                `https://netmax-play-api.vercel.app/api/v1/clientes/${currentData?.Id}`,
                {
                    method: "PUT",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${localStorage.getItem("token")}`,
                    },
                    body: JSON.stringify({ Conexion: updatedConexion }),
                }
            );

            // Guardar en localStorage y actualizar estado
            storedUserData.cliente = { ...currentData, Conexion: updatedConexion };
            localStorage.setItem("userSession", JSON.stringify(storedUserData));
            setUserData(storedUserData.cliente);

            setMessage("✅ Comprobante cargado correctamente");
            setTimeout(() => onClose(), 1000);

        } catch (err) {
            console.error(err);
            setMessage("❌ Ocurrió un error al cargar el comprobante");
        } finally {
            setLoading(false);
        }
    };


    return (
        <div className="text-black">
            <h1 className="text-2xl text-purple-800 font-semibold text-center mb-4">
                Informar pago
            </h1>
            <form onSubmit={handleSubmit} className="flex flex-col gap-4">
                <input
                    readOnly
                    value={userData?.Cliente || ""}
                    placeholder="Nombre del cliente"
                    className="border bg-gray-100 border-purple-300 p-2 rounded"
                />
                <input
                    type="number"
                    value={amount}
                    onChange={(e) => setAmount(e.target.value)}
                    placeholder="Monto a pagar"
                    required
                    className="border border-purple-300 p-2 rounded"
                />
                <select
                    required
                    value={selectedMonth}
                    onChange={(e) => setSelectedMonth(e.target.value)}
                    className="border border-purple-300 p-2 rounded"
                >
                    <option value="">Selecciona el mes</option>
                    {months.map((month) => (
                        <option key={month} value={month}>
                            {month}
                        </option>
                    ))}
                </select>
                <input
                    type="file"
                    required
                    onChange={handleFileChange}
                    className="border border-purple-300 p-2 rounded"
                />
                {uploadProgress > 0 && (
                    <div className="w-full bg-purple-100 rounded h-2 mt-2">
                        <div
                            className="bg-purple-600 h-2 rounded"
                            style={{ width: `${uploadProgress}%` }}
                        ></div>
                    </div>
                )}
                {message && (
                    <div className="text-sm text-center px-2 py-1 text-purple-800 bg-purple-100 rounded">
                        {message}
                    </div>
                )}
                <div className="flex justify-end gap-2 mt-2">
                    <button
                        type="button"
                        onClick={onClose}
                        className="bg-gray-300 text-gray-800 px-4 py-2 rounded hover:bg-gray-400"
                    >
                        Cancelar
                    </button>
                    <button
                        type="submit"
                        disabled={loading || !isUploadComplete}
                        className={`${loading || !isUploadComplete
                            ? "bg-purple-400 cursor-not-allowed"
                            : "bg-purple-700 hover:bg-purple-800"
                            } text-white px-4 py-2 rounded flex items-center gap-2`}
                    >
                        {loading ? (
                            <>
                                <FaSpinner className="animate-spin" />
                                Enviando...
                            </>
                        ) : (
                            "Enviar"
                        )}
                    </button>
                </div>
            </form>
        </div>
    );
};
